(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/pages/game-package-page.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/pages/game-package-page.js');

'use strict';

const {
  useWeekDrawUpdates
} = svs.gamePackage.hooks;
const {
  getInitialBalance,
  pay
} = svs.gamePackage.redux.thunks;
const {
  useDispatch
} = ReactRedux;
const {
  useEffect,
  useCallback
} = React;
const {
  Hero,
  Games,
  Payfooter,
  SizePicker,
  AccountSelectorContainer
} = svs.gamePackage.components;
const GamePackagePage = () => {
  useWeekDrawUpdates();
  const dispatch = useDispatch();
  const {
    images,
    textColor,
    heroContentList
  } = svs.gamePackage.data.hero;
  const handlePay = useCallback(() => {
    dispatch(pay());
  }, [dispatch]);
  useEffect(() => {
    if (svs.utils.paramHandler.get({
      key: 'pay'
    }).value && !svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      svs.utils.paramHandler.remove({
        key: 'pay'
      });
      svs.utils.paramHandler.remove({
        key: 'bag'
      });
    }
    if (svs.utils.paramHandler.get({
      key: 'pay'
    }).value) {
      handlePay();
    }
    dispatch(getInitialBalance());
  }, [handlePay, dispatch]);
  return React.createElement(React.Fragment, null, images && React.createElement(Hero, {
    images: images,
    textColor: textColor,
    heroContentList: heroContentList
  }), React.createElement(SizePicker, null), React.createElement(Games, null), React.createElement(AccountSelectorContainer, null), React.createElement(Payfooter, {
    onPay: handlePay
  }));
};
svs.gamePackage.components.GamePackagePage = GamePackagePage;

 })(window);